import {DomainEvent} from './DomainEvent';
import {Match} from '../resources/Match';

export class MatchStarted extends DomainEvent<Match> {}
